import axiosClient from "@/services/axiosClient";

export const OrganizationsService = {
  async fetchOrganizations({ amount, findstr, lastId }) {
    const url = "/organization";

    const params = {
      amount,
      findstr,
      lastId,
    };

    const response = await axiosClient.get(url, { params });

    return response.data;
  },
};
